import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { frenchNumberSchema } from '../tools/zod-schemas'

export const zPromoCampaignForm = z.object({
  type: z
    .string()
    .nonempty({ message: 'Le type de la campagne est requis' })
    .max(30, { message: 'Le type de la campagne doit contenir au maximum 30 caractères' }),
  name: z
    .string()
    .nonempty({ message: 'Le nom de la campagne est requis' })
    .max(30, { message: 'Le nom de la campagne doit contenir au maximum 30 caractères' }),

  targetIds: z.array(z.union([z.number(), z.string()])), // ID of target products, users...it could be a string for the menus ids
  storeTargetRefs: z.array(z.string()), // References of target stores

  reductionType: z
    .string()
    .nonempty({ message: 'Le type de réduction est requis' })
    .max(30, { message: 'Le type de réduction doit contenir au maximum 30 caractères' }),
  reductionValue: frenchNumberSchema.nullable(),

  // Date stored as a string for react-hook-form compatibility, but parsed for validation
  startDate: z.string().nonempty({ message: 'La date de début est requise' }),
  endDate: z.string().nonempty({ message: 'La date de fin est requise' }),
  campaignType: z.string().nonempty({ message: 'Le type de campagne est requis' }),
  publicCode: z.string().nullable(),
  quantityUniqueCode: z.string().nullable(),
})

export type PromoCampaignFormInput = z.input<typeof zPromoCampaignForm>
export type PromoCampaignFormOutput = z.output<typeof zPromoCampaignForm>

// Form hook
export const usePromoCampaignForm = (defaultValues?: PromoCampaignFormInput) => {
  const form = useForm({
    // Validation function
    defaultValues: {
      type: 'Produit',
      name: '',

      reductionType: 'Taux',
      storeTargetRefs: [],
      campaignType: 'private',
      publicCode: '',
      quantityUniqueCode: '0',
      targetIds: [],
      startDate: '',
      endDate: '',

      ...defaultValues,

      // Reformat some values to match the required validation
      reductionValue: defaultValues?.reductionValue,
    },
    resolver: zodResolver(zPromoCampaignForm),
  })

  return form
}
